import { createValueDialogStore } from '../create';

export const useComparisonDialog = createValueDialogStore<number[]>([]);
